import { type CreateImportSupportAccessRequest } from "@medicorepay/shared";
import { productRevivalApi } from "@/services/product-revival-client";

export type {
  ImportSupportAccess,
  ImportSupportJob,
  ImportSupportJobDetails,
} from "@medicorepay/shared";

export const importSupportService = {
  createAccess: (payload: CreateImportSupportAccessRequest) =>
    productRevivalApi.createImportSupportAccess(payload),

  getAccess: (accessId: string) =>
    productRevivalApi.getImportSupportAccess(accessId),

  endAccess: (accessId: string) =>
    productRevivalApi.endImportSupportAccess(accessId),

  listJobs: (
    accessId: string,
    filters: { status?: string; jobId?: string } = {},
  ) => productRevivalApi.listImportSupportJobs({ accessId, ...filters }),

  getJob: (accessId: string, jobId: string) =>
    productRevivalApi.getImportSupportJob(accessId, jobId),

  retry: (
    accessId: string,
    jobId: string,
    reason: string,
    idempotencyKey: string,
  ) =>
    productRevivalApi.retryImportSupportJob(
      jobId,
      { accessId, reason },
      { idempotencyKey, clientApplication: "admin" },
    ),
};
